import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import { Children } from 'react';
import types from 'prop-types';
import { withContext, getContext } from 'recompose';
var assign = _Object$assign;

var Provider = function Provider(_ref) {
  var children = _ref.children;
  return Children.only(children);
};

var textContextTypes = {
  text: types.objectOf(types.object).isRequired
};
var meta = {
  displayName: 'TextProvider',
  propTypes: textContextTypes,
  defaultProps: {
    text: {}
  }
};
export var TextProvider = assign(withContext(textContextTypes, function (_ref2) {
  var text = _ref2.text;
  return {
    text: text
  };
})(Provider), meta);
export default getContext(textContextTypes);